export default "__VITE_ASSET__BTIKZcf4__"